import React from "react";
import { Card, Row, Col, Avatar, Typography, Button } from "antd";
import { CheckSquareOutlined, BorderOutlined } from "@ant-design/icons";
import { getCardStyle } from "../../../../utils/getCardStyle";
import { getCardBackgroundColor } from "../detalleOrden/getCardBackgroundColor";
import "../../index.css";

const { Text } = Typography;

const PaletCard = ({
  item,
  darkMode,
  ordenActiva,
  onResetCantidad,
  onOpenLongPress,
  currentUbi,
  ubicacionResaltadaId,
  paletActivoVLX,
}) => {
  const isResaltado = item?.ubicacion_id === ubicacionResaltadaId;

  const isPaletActivo = paletActivoVLX?.idpale === item?.palet_id;

  return (
    <Card
      hoverable
      styles={{ body: { padding: 16 } }}
      style={{
        ...getCardStyle(darkMode),
        height: "100%",
        flex: 1,
        backgroundColor: getCardBackgroundColor(item.confirmada, item.cantidad),
        transition: "all 0.25s ease",

        border: isPaletActivo
          ? "3px solid #52c41a"
          : isResaltado
            ? "2px solid #1890ff"
            : undefined,

        boxShadow: isPaletActivo ? "0 0 0 2px rgba(82,196,26,0.18)" : undefined,
      }}
    >
      {/* FILA 1 */}
      <Row align="top" justify="space-between">
        <Col style={{ maxWidth: 350 }}>
          <Text
            strong
            style={{
              fontSize: 20,
              color: "#000",
              display: "block",
              whiteSpace: "normal",
              wordBreak: "break-word",
            }}
          >
            {item.palet_descripcion || `Palet ${item.palet_id}`}
          </Text>

          <Text strong style={{ display: "block", color: "#000" }}>
            {item?.valcar}
          </Text>
        </Col>

        <Col>
          <Text
            strong
            style={{
              fontSize: 20,
              color: "#000",
              whiteSpace: "nowrap",
            }}
          >
            {item.etiqueta}
          </Text>
        </Col>
      </Row>

      {/* FILA 2 */}
      <Row justify="space-between" align="middle" style={{ marginTop: 8 }}>
        <Col />
        <Col>
          <Avatar
            src="/assets/palet.png"
            size={60}
            style={{ backgroundColor: "#d5c279" }}
          />
        </Col>
      </Row>

      {/* FILA 3 */}
      <Row justify="space-between" align="middle" style={{ marginTop: 12 }}>
        <Col>
          {ordenActiva &&
            (item.confirmada >= item.cantidad ? (
              <Button
                type="text"
                onClick={() => onResetCantidad(item)}
                icon={
                  <CheckSquareOutlined
                    className="custom-icon"
                    style={{ fontSize: 36, color: "#000" }}
                  />
                }
              />
            ) : (
              <Button
                type="text"
                icon={
                  <BorderOutlined
                    className="custom-icon"
                    style={{ fontSize: 36, color: "#000" }}
                  />
                }
                onClick={() => onOpenLongPress({ ...item, currentUbi })}
              />
            ))}
        </Col>

        <Col>
          <Text
            strong
            type="secondary"
            style={{
              fontSize: 20,
              color: "#000",
            }}
          >
            {Math.round(item.confirmada)} de {Math.round(item.cantidad)}
          </Text>
        </Col>
      </Row>
    </Card>
  );
};

export default PaletCard;
